import getSearchUrl from '@rover/react-lib/src/utils/getSearchUrl';
import {
  OptimizedSearchResult,
  ServiceType as RSDKServiceType,
} from '@rover/rsdk/src/apiClient/latest';
import { SearchFilters } from '@rover/types';
import { ServiceType } from '@rover/types/src/ServiceType';

const getSelectedSitterSearchUrl = (
  filters: Partial<SearchFilters>,
  language: string,
  searchResult: OptimizedSearchResult,
  serviceTypeConfig?: ServiceType | RSDKServiceType | null | undefined
): string => {
  const selectedOpk =
    searchResult.isFacility && searchResult.facilityOpk
      ? searchResult.facilityOpk
      : searchResult.personOpk;

  const selectedEntityParams = searchResult.isFacility
    ? { selectedFacility: selectedOpk, selectedProvider: '' }
    : { selectedFacility: '', selectedProvider: selectedOpk };

  return getSearchUrl(
    {
      ...filters,
      ...selectedEntityParams,
    },
    language,
    serviceTypeConfig,
    false
  );
};

export default getSelectedSitterSearchUrl;
